import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { App } from '@df/core/app';
import { UiComponent } from '@df/ui/ui.component';

@Component({
    selector: 'pwa-back-button',
    templateUrl: './pwa-back-button.html',
    styleUrls: ['./pwa-back-button.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PwaBackButtonComponent extends UiComponent {
    private router = inject(Router);
    private app = inject(App);

    protected currentPath = '';

    override ngOnInit(): void {
        super.ngOnInit();

        if (this.app.isPlatformBrowser) {
            this.currentPath = this.router.url;

            this.subscriptions.add(
                this.router.events.subscribe(event => {
                    if (event instanceof NavigationEnd) {
                        this.currentPath = event.url;
                        this.detectChanges();
                    }
                })
            );
        }
    }

    protected goBack(): void {
        if (this.app.meta.previousState) {
            window.history.back();
            return;
        }
        this.router.navigateByUrl('/');
    }

    protected get shouldShow(): boolean {
        if (!this.app.isPlatformBrowser) {
            return false;
        }

        // Check if there's a page to go back to
        const hasPageToGoBack = this.app.meta.previousState || window.history.length > 1;
        if (!hasPageToGoBack) {
            return false;
        }

        const excludedPaths = ['/basket', '/checkout', '/account', '/outfit-builder', '/pony-kit-builder'];

        // Extract the pathname without query parameters to properly check for homepage
        const pathname = this.currentPath.split('?')[0];
        const isHomepage = pathname === '/' || pathname === '';

        return !excludedPaths.some(path => this.currentPath.includes(path)) && !isHomepage;
    }
}
